import useProtoMethod from "./useProtoMethod";
import {
  ArchiveEmailsRequest,
  ArchiveEmailsResponse,
  AssignEmailToInboxRequest,
  AssignEmailToInboxResponse,
  CreateOrUpdateEmailDraftRequest,
  CreateOrUpdateEmailDraftResponse,
  DeleteEmailDraftRequest,
  DeleteEmailDraftResponse,
  FetchAutocompleteEntriesRequest,
  FetchAutocompleteEntriesResponse,
  FetchEmailInboxRequest,
  FetchEmailInboxResponse,
  FetchUnassignedEmailsRequest,
  FetchUnassignedEmailsResponse,
  GetEmailDraftRequest,
  GetEmailDraftResponse,
  GetEmailThreadRequest,
  GetEmailThreadResponse,
  GetMemberTaskEmailRequest,
  GetMemberTaskEmailResponse,
  MarkEmailsUnreadStatusRequest,
  MarkEmailsUnreadStatusResponse,
  SendEmailDraftRequest,
  SendEmailDraftResponse,
  SetEmailFolderRequest,
  SetEmailFolderResponse,
  ListEmailFoldersRequest,
  ListEmailFoldersResponse,
  CreateEventFromEmailAttachmentRequest,
  CreateEventFromEmailAttachmentResponse,
  GetMemberEmailResponse,
  GetMemberEmailRequest,
  FetchMemberEmailInboxRequest,
  FetchMemberEmailInboxResponse,
  MarkSenderAsSpamRequest,
  MarkSenderAsSpamResponse,
  UnmarkSenderAsSpamRequest,
  UnmarkSenderAsSpamResponse,
} from "protogen/email_service_pb";

const useFetchUnassignedEmails = (
  callback?: (r: FetchUnassignedEmailsResponse) => void,
) => {
  return useProtoMethod<
    FetchUnassignedEmailsRequest,
    FetchUnassignedEmailsResponse
  >("FetchUnassignedEmails", FetchUnassignedEmailsResponse, { callback });
};

const useAssignEmailToInbox = (
  callback?: (r: AssignEmailToInboxResponse) => void,
) => {
  return useProtoMethod<AssignEmailToInboxRequest, AssignEmailToInboxResponse>(
    "AssignEmailToInbox",
    AssignEmailToInboxResponse,
    { callback },
  );
};

const useGetEmailDraft = (callback?: (r: GetEmailDraftResponse) => void) => {
  return useProtoMethod<GetEmailDraftRequest, GetEmailDraftResponse>(
    "GetEmailDraft",
    GetEmailDraftResponse,
    { callback },
  );
};

const useUpdateEmailDraft = (
  callback?: (r: CreateOrUpdateEmailDraftResponse) => void,
) => {
  return useProtoMethod<
    CreateOrUpdateEmailDraftRequest,
    CreateOrUpdateEmailDraftResponse
  >("CreateOrUpdateEmailDraft", CreateOrUpdateEmailDraftResponse, { callback });
};

const useDeleteEmailDraft = (
  callback?: (r: DeleteEmailDraftResponse) => void,
) => {
  return useProtoMethod<DeleteEmailDraftRequest, DeleteEmailDraftResponse>(
    "DeleteEmailDraft",
    DeleteEmailDraftResponse,
    { callback },
  );
};

const useSendEmailDraft = (callback?: (r: SendEmailDraftResponse) => void) => {
  return useProtoMethod<SendEmailDraftRequest, SendEmailDraftResponse>(
    "SendEmailDraft",
    SendEmailDraftResponse,
    { callback },
  );
};

const useGetEmailThread = (callback?: (r: GetEmailThreadResponse) => void) => {
  return useProtoMethod<GetEmailThreadRequest, GetEmailThreadResponse>(
    "GetEmailThread",
    GetEmailThreadResponse,
    { callback },
  );
};

const useFetchEmailInbox = (
  callback?: (r: FetchEmailInboxResponse) => void,
) => {
  return useProtoMethod<FetchEmailInboxRequest, FetchEmailInboxResponse>(
    "FetchEmailInbox",
    FetchEmailInboxResponse,
    { callback },
  );
};

const useMarkEmailsUnreadStatus = (
  callback?: (r: MarkEmailsUnreadStatusResponse) => void,
) => {
  return useProtoMethod<
    MarkEmailsUnreadStatusRequest,
    MarkEmailsUnreadStatusResponse
  >("MarkEmailsUnreadStatus", MarkEmailsUnreadStatusResponse, { callback });
};

const useArchiveEmails = (callback?: (r: ArchiveEmailsResponse) => void) => {
  return useProtoMethod<ArchiveEmailsRequest, ArchiveEmailsResponse>(
    "ArchiveEmails",
    ArchiveEmailsResponse,
    { callback },
  );
};

const useFetchAutocompleteEntries = (
  callback?: (r: FetchAutocompleteEntriesResponse) => void,
) => {
  return useProtoMethod<
    FetchAutocompleteEntriesRequest,
    FetchAutocompleteEntriesResponse
  >("FetchAutocompleteEntries", FetchAutocompleteEntriesResponse, { callback });
};

const useGetMemberTaskEmail = (
  callback?: (r: GetMemberTaskEmailResponse) => void,
) => {
  return useProtoMethod<GetMemberTaskEmailRequest, GetMemberTaskEmailResponse>(
    "GetMemberTaskEmail",
    GetMemberTaskEmailResponse,
    { callback },
  );
};

const useGetMemberEmail = (callback?: (r: GetMemberEmailResponse) => void) => {
  return useProtoMethod<GetMemberEmailRequest, GetMemberEmailResponse>(
    "GetMemberEmail",
    GetMemberEmailResponse,
    { callback },
  );
};

const useSetEmailFolder = (callback?: (r: SetEmailFolderResponse) => void) => {
  return useProtoMethod<SetEmailFolderRequest, SetEmailFolderResponse>(
    "SetEmailFolder",
    SetEmailFolderResponse,
    { callback },
  );
};

const useListEmailFolders = (
  callback?: (r: ListEmailFoldersResponse) => void,
) => {
  return useProtoMethod<ListEmailFoldersRequest, ListEmailFoldersResponse>(
    "ListEmailFolders",
    ListEmailFoldersResponse,
    { callback },
  );
};

const useCreateEventFromEmailAttachment = (
  callback?: (r: CreateEventFromEmailAttachmentResponse) => void,
) => {
  return useProtoMethod<
    CreateEventFromEmailAttachmentRequest,
    CreateEventFromEmailAttachmentResponse
  >("CreateEventFromEmailAttachment", CreateEventFromEmailAttachmentResponse, {
    callback,
  });
};

const useFetchMemberEmailInbox = (
  callback?: (r: FetchMemberEmailInboxResponse) => void,
) => {
  return useProtoMethod<
    FetchMemberEmailInboxRequest,
    FetchMemberEmailInboxResponse
  >("FetchMemberEmailInbox", FetchMemberEmailInboxResponse, { callback });
};

const useMarkSenderAsSpam = (
  callback?: (r: MarkSenderAsSpamResponse) => void,
) => {
  return useProtoMethod<MarkSenderAsSpamRequest, MarkSenderAsSpamResponse>(
    "MarkSenderAsSpam",
    MarkSenderAsSpamResponse,
    { callback },
  );
};

const useUnmarkSenderAsSpam = (
  callback?: (r: UnmarkSenderAsSpamResponse) => void,
) => {
  return useProtoMethod<UnmarkSenderAsSpamRequest, UnmarkSenderAsSpamResponse>(
    "UnmarkSenderAsSpam",
    UnmarkSenderAsSpamResponse,
    { callback },
  );
};

export {
  useFetchUnassignedEmails,
  useAssignEmailToInbox,
  useGetEmailDraft,
  useUpdateEmailDraft,
  useDeleteEmailDraft,
  useSendEmailDraft,
  useGetEmailThread,
  useFetchEmailInbox,
  useMarkEmailsUnreadStatus,
  useArchiveEmails,
  useFetchAutocompleteEntries,
  useGetMemberTaskEmail,
  useGetMemberEmail,
  useSetEmailFolder,
  useListEmailFolders,
  useCreateEventFromEmailAttachment,
  useFetchMemberEmailInbox,
  useMarkSenderAsSpam,
  useUnmarkSenderAsSpam,
};
